<template>
  <div>
    <transition name="fade">
      <v-overlay :z-index="201" v-if="show"></v-overlay>
    </transition>
    <v-dialog :value="show" persistent hide-overlay>
      <v-card color="primary darken-1" dark class="unmarkable">
        <v-card-text>
          {{ descriptionText }}
          <v-progress-linear indeterminate color="white" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProgressComponent",
  data: function() {
    return {
      show: false
    };
  },
  computed: {
    ...mapState("progressComponent", [
      "showIndeterminateLoading",
      "descriptionText"
    ])
  },

  watch: {
    showIndeterminateLoading(newValue) {
      this.show = newValue;
    }
  }
};
</script>

<style scoped></style>
